export default function () {
  const bodyElement = document.querySelector('body');
  const keydownClass = 'c-key-down';
  // Using mousedown instead of mouseover, so that previously focused elements don't lose focus
  // ring on mouse move
  bodyElement.addEventListener('mousedown', () => {
    bodyElement.classList.remove(keydownClass);
  });
  // keydown listener
  bodyElement.addEventListener('keydown', (e) => {
    const keyCode = e.keyCode || e.which;

    if (keyCode === 9) {
      bodyElement.classList.add(keydownClass);
    }
  });
}
